"use strict";
exports.__esModule = true;
var ramda_1 = require("ramda");
exports["default"] = ramda_1.pick([
    'x',
    'y',
    'width',
    'height',
    'preserveAspectRatio',
    'viewBox',
    'zoomAndPan',
]);
//# sourceMappingURL=svg.js.map